import { render, staticRenderFns } from "./SerieNumeroFormSerieActiva.vue?vue&type=template&id=db70ae3a&"
import script from "./SerieNumeroFormSerieActiva.vue?vue&type=script&lang=ts&"
export * from "./SerieNumeroFormSerieActiva.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('db70ae3a', component.options)
    } else {
      api.reload('db70ae3a', component.options)
    }
    module.hot.accept("./SerieNumeroFormSerieActiva.vue?vue&type=template&id=db70ae3a&", function () {
      api.rerender('db70ae3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ReportesSerie/SerieNumeroFormSerieActiva.vue"
export default component.exports